import React, { Fragment } from "react"
import { connect } from "react-redux"
import { FORM_REFS } from '../../../../constants';
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import { eapiClient, aemHostClient, taxonomyHostClient } from '../../../../restClient';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import GlsNotionalPoolingStrucutre from './GlsNotionalPoolingStrucutre'
import {
    Translations,
    checkIsNA,
    convertStringToArrayForOption,
    isEmptyObject
} from '../../../../utils';
import SimpleDropdown from '../../../common/SimpleDropdown';
import SweepFrequencyPicker from '../../../common/SweepFrequencyPicker';
import Checkbox from '../../../common/Checkbox';
import Radiobutton from '../../../common/Radio/radioButton';


import {
    setProductNotionalPooling,
    setStatus,
    setPartyCurrency,
    setPageJson,
    setPageJson1,
    setPageJson2,
    setPageJsonAccordian,
} from './../../../CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/actions/actionCreator';
import { setSowProductAllAccounts, setSowSelectedProduct } from "../../../createASow/actions/actionCreator";
import './index.css';
import './OtherSetting.css'
import CCRRateBox from "../../../common/CCRRateBox";
import classNames from "classnames";
class NotionalPoolSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formRef: {},
            noOfReporting: 1,
            reportedEChannelId: '',
            eChannelReported: '',
            dataReady: false,
            notionalPoolingTitle: "",
            interestOptimisations: [],
            allAccounts: [],
            isdeletePool: false,
            baseCurrency: [],
            selectedBaseCurrency: '',
            // unauthorizedInterestTypeFloating: "",
            // unauthorizedInterestTypeFixed: false,
            checkODLimit: true,
            odLimit: 'N/A',
            unauthorisedOD: this.getInitialUnauthorisedODObject(),
            frequencyInfo: {
                timeZone: null,
                frequencyType: {
                    name: "Monthly",
                    value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
                },
                frequencyDetails: {
                    name: null,
                    value: null
                },
                frequencyDetailValue: {
                    name: null,
                    value: null
                },
                annualDate: null,
                dates: []
            },
        }
        this.reportingEchannelDisableList = []
        this.renderInterestOptimization = this.renderInterestOptimization.bind(this);
        this.payload = new NotionalPoolingPayload()
        // this.payloadBasicDetail = new basicDetailPayload();
        this.payloadOtherSetting = new otherSettingPayload();
        this.payloadInterestOptimization = new interestOptimizationPayload();
        // this.payloadEchannelReportingSection = new EchannelReportingSection();
        this.dataDictionaryURI = `/product/taxonomies/interestPeriodSettlementDate`;
        // this.apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
        // this.apiURL = "/product/gls/" + productId;
        this.apiURLPartyCurrency = `/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:AllCurrency`;
        // this.apiURLBasicDetailAcc = `/product/gls/${productId}/case/${caseId}/account/`;
        // this.apiURLDeletePool = `/product/gls/notionalPool/${productId}/cancelPool/`;
        this.apiURLNPFromJson = "/aemData/formData/json_sow-notional-pooling-all-closed";
        // this.apiURLNPInterestOptiForm = "/aemData/formData/json_sow-notional-pooling-interest-optimisation-settings-form";
        // this.apiURLPageJson = "/aemData/formData/json_notional-pooling-page";
        this.apiURLPageJson1 = "/aemData/formData/json_sow-pooling-structure";
        this.apiURLPageJson2 = "/aemData/formData/json_sow-other-settings";
        // this.apiURLNPInterstOptimization = "/aemData/formData/json_gls-interest-optimisation";
        // this.apiURLDeleteStandAlone = `/product/gls/notionalPool/${productId}/cancelPool/`;
        // this.apiURLModal = "/aemData/formData/json_notionla-pooling-modal-page";
        //  this.interestPeriodSettlementDate = `/product/taxonomies/interestPeriodSettlementDate/`;
    }


    componentWillMount() {

        /*api call for form json*/
        // loadIfStateAvailableInSessionStorage(this, null, () => {
        //     this.loadPageState();
        // });

        aemHostClient(this.apiURLNPFromJson)
            .then(({ data }) => {
                this.setState({
                    formJson: data
                });
                // this.getInterestPeriodSettlementDate();
                this.props.setPageJsonAccordian(data.par.dynamic_accordion_list_notionalpooling);
            });

        /*api call for Notaionl pageJSON*/
        aemHostClient(this.apiURLPageJson1)
            .then(({ data }) => {
                if (data.par !== 'undefined' && data.par.staticText_notionalPooling !== 'undefined' && data.par.guidedropdownlist_location !== 'undefined') {
                    //this.setState({pageJson: data.par.notional_pooling});
                    // this.props.setPageJson(data.par.guidedropdownlist_location);
                    this.props.setPageJson1({ ...data.par.staticText_notionalPooling, ...data.par.guidedropdownlist_location });
                }
            });

        aemHostClient(this.apiURLPageJson2)
            .then(({ data }) => {
                if (data.par !== 'undefined' && data.par.staticText_otherSettings !== 'undefined') {
                    //this.setState({pageJson: data.par.notional_pooling});
                    this.props.setPageJson2(data.par.staticText_otherSettings);
                }
            });



        /*api call for apiURLPartyCurrency*/
        taxonomyHostClient(this.apiURLPartyCurrency, { method: 'GET' })
            .then(({ data }) => {
                this.props.setPartyCurrency(data.responseData);
            });

        this.getGLSProductDetails()
        this.loadTabStatus();
        this.getAllAccounts();
    }



    componentDidMount = () => {
        //Pool and Standalone
        if (this.props.selectedSowProduct && this.props.selectedSowProduct.notionalPooling && !isEmptyObject(this.props.selectedSowProduct.notionalPooling.otherSettings)) {
            const { unauthorisedOD, baseCurrency, frequencyInfo, odLimit } = this.props.selectedSowProduct.notionalPooling.otherSettings
            const updatedOtherSettings = {}
            if (unauthorisedOD) {
                updatedOtherSettings.unauthorisedOD = unauthorisedOD
            }
            if (baseCurrency && baseCurrency.name) {
                updatedOtherSettings.selectedBaseCurrency = baseCurrency.name
            }
            if (frequencyInfo) {
                updatedOtherSettings.frequencyInfo = frequencyInfo
            }
            if (odLimit !== undefined) {
                updatedOtherSettings.odLimit = odLimit
                updatedOtherSettings.checkODLimit = checkIsNA(odLimit, true)
            }
            this.setState(updatedOtherSettings)
            this.setMyValue()
        }

        if (this.props.selectedSowProduct !== undefined && this.props.currency !== undefined) {
            if (this.props.poolIdAfterSaveRefresh !== undefined) {
                this.props.resetPoolIdAfterSaveReferesh();
            }
            let standAloneAccount = this.props.selectedSowProduct.notionalPooling.poolingStructure.standAloneAccount || [];
            let pools = this.props.selectedSowProduct.notionalPooling.poolingStructure.pools || [];
            let accounts = this.props.accounts;
            let currency = this.props.currency;
            let baseCurrency = [];
            //var distinctCurrnecies = [];
            //var unique = {};
            // if (typeof this.props.selectedSowProduct.notionalPooling.otherSettings.frequencyInfo !== 'undefined' && Object.keys(this.props.selectedSowProduct.notionalPooling.otherSettings.frequencyInfo).length > 0) {
            //     this.setState({
            //         isloadSweep: true
            //     })
            // }

            // if (typeof this.props.selectedSowProduct.notionalPooling.otherSettings.odLimit !== 'undefined' && this.props.selectedSowProduct.notionalPooling.otherSettings.odLimit === 'N/A') {
            //     this.setState({
            //         checkODLimit: true
            //     })
            // } else {
            //     this.setState({
            //         checkODLimit: false
            //     })
            // }

            standAloneAccount.map((standAloneId) => {
                accounts.filter((item) => {
                    if (standAloneId === item.id) {
                        baseCurrency.push(item.currency);
                    }
                });
            });

            pools.map((currencyVal) => {
                if (typeof currencyVal.poolCurrency !== 'undefined') {
                    let currencyNew = currencyVal.poolCurrency;
                    currency.classificationNodes.filter((item) => {
                        if (currencyNew.name === item.name) {
                            let obj = {
                                name: item.name,
                                value: item.id
                            }
                            baseCurrency.push(obj);
                        }
                    });
                }
            });

            this.setState({
                baseCurrency: this.removeDuplicates(baseCurrency, 'value')
            })

        }

        //Interest Optimization 
        this.setState({
            dataReady: true,
            notionalPoolingTitle: this.props.selectedSowProduct.notionalPoolingTitle,
            interestOptimisations: this.props.selectedSowProduct.notionalPooling.interestOptimisations || [],
            isIERequired: this.props.selectedSowProduct.notionalPooling.isIERequired
        })

        this.payload.setPrePopulateData(this.props.selectedSowProduct.notionalPooling.poolingStructure)
        this.onSowProductUpdate(this.props.selectedSowProduct)
    }

    onSowProductUpdate = (data) => {
        if (data !== undefined) {
            let poolID = [], standID = [];
            if (data.notionalPooling !== undefined && data.notionalPooling.poolingStructure !== undefined && data.notionalPooling.poolingStructure.pools !== null) {
                poolID = data.notionalPooling.poolingStructure.pools.map(item => item.id)
            }
            if (data.notionalPooling !== undefined && data.notionalPooling.poolingStructure !== undefined && data.notionalPooling.poolingStructure.standAloneAccount !== null) {
                standID = data.notionalPooling.poolingStructure.standAloneAccount.map(item => item)
            }
            const allAcc = data.notionalPooling !== undefined && data.notionalPooling.interestOptimisations !== undefined ? data.notionalPooling.interestOptimisations : [];
            if ((allAcc !== undefined && allAcc !== null) && (poolID !== undefined || standID !== undefined)) {
                var myPool = allAcc.filter((item) => poolID.includes(item.id));
                var myStand = allAcc.filter((item) => standID.includes(item.id));
                this.setState({
                    poolID: myPool,
                    standID: myStand
                })
            }
        }
    }

    onChangeBaseCurrency = (event) => {
        let str = event.target.value;
        var res = str.split(":");
        let localObj = {
            name: 'otherSettings',
            values: {
                frequencyInfo: this.state.frequencyInfo,
                baseCurrency: {
                    name: res[res.length - 1],
                    value: event.target.value,
                }
            }
        }

        this.setState({
            selectedBaseCurrency: event.target.value
        });
        this.getData(localObj);
    }

    setFormElementData = (data) => {
        this.setState({
            frequencyInfo: data
        })

        let localObj = {
            name: 'otherSettings',
            values: {
                frequencyInfo: data,
                baseCurrency: {
                    name: this.state.selectedBaseCurrency,
                    value: this.state.selectedBaseCurrency
                }
            }
        }
        this.getData(localObj);
    }
    removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            if (i !== 'undefined') {
                newArray.push(lookupObject[i]);
            }
        }
        return newArray;
    }

    openDeletePool = (e, id) => {
        if (id !== '') {
            let { productId } = this.props.match.params;
            const apiURLDeletePool = `/sows/${productId}/deletePool/${id}`;
            eapiClient(apiURLDeletePool, {
                method: "DELETE"
            })
                .then(({ data }) => {
                    if (!isEmptyObject(data.responseData)) {
                        this.props.setSowSelectedProduct(data.responseData)
                    }
                    this.loadTabStatus()
                    this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
                    this.onSowProductUpdate(data.responseData)
                });
        }
    }

    translations = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    // Other setting
    onOtherSettingTabDataSubmit = () => {
        let { productId } = this.props.match.params;
        let apiOtherUrl = `/sows/${productId}/glses`;

        if (this.props.mode === 'edit') {
            apiOtherUrl = apiOtherUrl + "/" + this.state.formData.id;
        }

        eapiClient(apiOtherUrl, {
            method: "PUT",
            data: JSON.stringify(this.payloadOtherSetting.getPayload())
        })
            .then(({ data }) => {
                // this.props.setProductNotionalPooling(data.responseData);
                this.loadTabStatus();
                this.props.setSowSelectedProduct(data.responseData)
                this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
                this.onSowProductUpdate(data.responseData)
            });
    }

    loadTabStatus = () => {
        /*api call for Tab Status*/
        let apiUrl;
        let { caseId } = this.props.match.params;
        apiUrl = this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined ?
            `/sows/${caseId}/notionalPoolStatus?isNavigate=true` : `/sows/${caseId}/notionalPoolStatus`
        eapiClient(apiUrl)
            .then(({ data }) => {
                if (data.responseData) {
                    this.setState({
                        sowNotionalPoolStatus: data.responseData
                    })
                }
            });
    }

    getInterestOptimizationData = (index, interestOptimizationData) => {
        var interestOptimisations = [...this.state.interestOptimisations];
        interestOptimisations.filter((interestOpt, index) => {
            if (interestOpt.id === interestOptimizationData.id) {
                interestOptimisations[index] = interestOptimizationData;
            }
        })
        this.setState({ interestOptimisations });
        let localpayloadBlockObject = {
            name: "interestOptimisations",
            values: interestOptimisations
        }
        this.payload.setPaylod(localpayloadBlockObject);
        this.payloadInterestOptimization.setPaylod(localpayloadBlockObject)
    }

    renderInterestOptimization = (account, index) => {
        let formData = {};
        if (account !== undefined && account.id !== undefined) {
            formData = { ...account }
            if ("coveredCreditBalance" in account) {
                if ("rate" in account.coveredCreditBalance === false) {
                    formData.coveredCreditBalance = {
                        rate: false
                    }
                }
            } else {
                formData['coveredCreditBalance'] = {
                    rate: 'fixed'
                }
            }
            if ("coveredDebitBalance" in account) {
                if ("rate" in account.coveredDebitBalance === false) {
                    formData.coveredDebitBalanc = {
                        rate: false
                    }
                }
            } else {
                formData['coveredDebitBalance'] = {
                    rate: 'fixed'
                }
            }
            if ("residualDebitBalance" in account) {
                if ("rate" in account.residualDebitBalance === false) {
                    formData.residualDebitBalance = {
                        rate: false
                    }
                }
            } else {
                formData['residualDebitBalance'] = {
                    rate: 'fixed'
                }
            }
            if ("residualCreditBalance" in account) {
                if ("rate" in account.residualCreditBalance === false) {
                    formData.residualCreditBalance = {
                        rate: false
                    }
                }
            } else {
                formData['residualCreditBalance'] = {
                    rate: 'fixed'
                }
            }
            if ("unAuthorisedOD" in account) {
                if ("rate" in account.unAuthorisedOD === false) {
                    formData.unAuthorisedOD = {
                        rate: false
                    }
                }
            } else {
                formData['unAuthorisedOD'] = {
                    rate: 'fixed',
                    interestRateType: "baseRate"
                }
            }
            if ("unauthorizedInterestType" in account === false) {
                formData.unauthorizedInterestType = "floating"
            }
            if (!("odLimit" in account)) {
                formData.odLimit = "N/A"
            }
        }
        else {
            formData['coveredCreditBalance'] = {
                rate: 'fixed'
            }
            formData['coveredDebitBalance'] = {
                rate: 'fixed'
            }
            formData['residualDebitBalance'] = {
                rate: 'fixed'
            }
            formData['residualCreditBalance'] = {
                rate: 'fixed'
            }
            formData['unAuthorisedOD'] = {
                rate: 'fixed',
                interestRateType: "baseRate"
            }
            formData['unauthorizedInterestType'] = "floating"
            formData['odLimit'] = 'N/A'
        }
        //Account Details of Pool and StandAlone accountType Start
        var formHeader = (<div></div>);
        if (typeof this.props.basicDetailsAccounts !== 'undefined') {
            let filterAcc = this.props.basicDetailsAccounts.filter(acc => acc.id === account.id);
            if (typeof filterAcc[0] !== 'undefined') {
                let filAcc = filterAcc[0];
                if (filAcc !== 'undefined') {
                    formHeader = (
                        <div className="form-header">
                            <div className='interset-opt-wrap'>
                                <div className="stand-acc-header"><b>{this.translations(this.props.pageJson1.standaloneAccount)}</b></div>
                                <div className="linkCursorHeader stand-acc-details">
                                    <span>
                                        {
                                            filAcc.accountNumber !== undefined
                                                ? <b>
                                                    {`${filAcc.accountNumber !== undefined ? filAcc.accountNumber + ',' : ''}`}
                                                    {`${filAcc.branchCode !== undefined ? filAcc.branchCode + ',' : ''}`}
                                                    {`${filAcc.location !== undefined && filAcc.location.name !== undefined ? filAcc.location.name + ',' : ''}`}
                                                    {`${filAcc.currency !== undefined && filAcc.currency.name !== undefined ? filAcc.currency.name : ''}`}
                                                </b>
                                                : <b>
                                                    {`${filAcc.accountType !== undefined ? filAcc.accountType.name + ',' : ''}`}
                                                    {`${filAcc.location !== undefined && filAcc.location.name !== undefined ? filAcc.location.name + ',' : ''}`}
                                                    {`${filAcc.currency !== undefined && filAcc.currency.name !== undefined ? filAcc.currency.name : ''}`}
                                                </b>
                                        }
                                    </span>
                                    <p>{`${filAcc.accountHolder !== undefined ? filAcc.accountHolder.name : ''}`}</p>
                                    <p>{filAcc.accountTitle !== undefined ? `(${filAcc.accountTitle})` : ''}</p>
                                </div>
                            </div>
                        </div>
                    );
                }
            } else {
                let filterpool = this.props.selectedSowProduct.notionalPooling.poolingStructure.pools.filter(pool => pool.id === account.id);
                if (typeof filterpool[0] !== 'undefined') {
                    // let filpool = filterpool[0];
                    let accountLenght = filterpool[0].accounts.length || 0
                    let poolCurrency = filterpool[0].poolCurrency;
                    formHeader = (
                        <div className="form-header intersetOptimisation">
                            <ul>
                                <li>{poolCurrency !== undefined ? `${poolCurrency.name} 'Pool' -` : ''}</li>
                                <li>{this.translations(this.props.pageJson1.singleCurrency)}</li>
                                <li>{poolCurrency !== undefined ? poolCurrency.name : ''}</li>
                                <li>{accountLenght} {this.translations(this.props.pageJson1.accounts)}</li>
                            </ul>
                        </div>
                    );
                    // let interestOptimisationsData = this.props.selectedSowProduct.notionalPooling.interestOptimisations.filter(interestOptimisations => interestOptimisations.id === account.id);
                    // if(interestOptimisationsData[0] !== undefined){
                    //   let filterinterestOptimisationsData = filterpool[0].allocationSettings;
                    //   if('unauthorisedOD' in filterinterestOptimisationsData){
                    //     formData.unAuthorisedOD = filterinterestOptimisationsData.unauthorisedOD;
                    //   }
                    //   setDiableFalg = true;
                    // }
                }
            }
        }

        //Account Details of Pool and StandAlone accountType end
        const properties = {
            glsCashconId: this.props.match.params.productId,
            caseId: this.props.match.params.caseId,
            formData,
            editType: 'gls-cashcon-aacount-interest-and-limits',
            pathname: this.props.history.location.pathname
        };

        if (this.state.formJson !== undefined && this.state.formJson.par.aemform_interestOptimisation !== undefined) {
            var aemform = this.state.formJson.par.aemform_interestOptimisation;
            var formRef = this.state.formJson.par.aemform_interestOptimisation.formRef;
            if (aemform !== undefined && formRef !== undefined) {
                var url = FORM_REFS[formRef];
                return (
                    <Dynamicform
                        mode="edit"
                        key={account.id}
                        properties={properties}
                        hideButtons={true}
                        getFormData={this.getInterestOptimizationData.bind(this, index)}
                        history={this.props.history}
                        url={url}
                        italyIndex={index}
                        fieldPrefix={index}
                        formHeader={formHeader}
                        lang={this.props.lang.currentLang.lang}
                        translatedData={this.props.lang.translatedData}
                    />
                );
            }
        }
    }

    translateWord = (word) => {
        var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
        var convertedArray = convertStringToArrayForOption(currentWord);
        return convertedArray;
    }

    renderPoolForm = (pool) => {
        if (pool !== undefined && pool.length > 0) {
            return pool.map((item, key) => item.id && this.renderInterestOptimization(item, key + 'pool'));
        }
    }

    renderStandAlonForm = (stand) => {
        if (stand !== undefined && stand.length > 0) {
            return stand.map((item, key) => item.id && this.renderInterestOptimization(item, key + 'stand'));
        }
    }

    getInterestOptimizationDataOnNoSelection = () => {
        const interestOptimisations = [...this.state.interestOptimisations];
        let localpayloadBlockObject = {
            name: "interestOptimisations",
            values: interestOptimisations
        }
        this.payload.setPaylod(localpayloadBlockObject);
        this.payloadInterestOptimization.setPaylod(localpayloadBlockObject)
    }

    handleSweepParticipantsRadioChange = (value, name) => {
        this.setState({
            isIERequired: value
        });
        //this.props.isSweepOrderRequired(value);
    }

    // Interest Optimization Section
    onInterestOptimizationTabDataSubmit = () => {
        this.props.blockUi && this.props.blockUi()
        const { productId } = this.props.match.params;
        if (productId) {
            let apiURL = `/sows/${productId}/glses`;
            let id = this.props.selectedSowProduct.id;
            let lid = this.props.selectedSowProduct.lid;
            let data = this.payloadInterestOptimization.getPayload();
            if (this.state.isIERequired !== undefined) {
                data.notionalPooling.isIERequired = this.state.isIERequired
            }
            let requestData = {
                ...data,
                id: id,
                lid: lid
            };

            if (this.props.mode === 'edit') {
                apiURL = apiURL + "/" + this.state.formData.id;
            }
            eapiClient(apiURL, {
                method: "PUT",
                data: JSON.stringify(requestData)
            })
                .then(({ data }) => {
                    this.props.setProductNotionalPooling(data.responseData);
                    this.loadTabStatus();
                    this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
                    this.onSowProductUpdate(data.responseData)
                    this.props.unBlockUi && this.props.unBlockUi()
                });
        }

    }
    getAllAccounts = () => {
        this.props.blockUi && this.props.blockUi()
        const apiUrl = `/sows/${this.props.savedSow && this.props.savedSow.sowId}/allAccounts`
        eapiClient(apiUrl).then(({ data }) => {
            if (Array.isArray(data.responseData) && data.responseData.length) {
                this.setState({
                    allAccounts: data.responseData.filter(acc => !acc.isThirdPartyAccount)
                })
                this.props.setSowProductAllAccounts(data.responseData.filter(acc => !acc.isThirdPartyAccount))
            }
            this.props.unBlockUi && this.props.unBlockUi()
        })
    }

    _getData = (event) => {
        switch (event.target.name) {
            case 'odLimit':
                this.setState({
                    odLimit: checkIsNA(event.target.value),
                    checkODLimit: checkIsNA(event.target.value, true)
                }, () => this.setMyValue());
                break;
            case 'unauthorisedODbaseRate':
                this.setState({
                    unauthorisedOD: {
                        ...this.state.unauthorisedOD,
                        baseRate: event.target.value
                    }
                }, () => this.setMyValue())
                break;
            case 'unauthorisedODCode':
                this.setState({
                    unauthorisedOD: {
                        ...this.state.unauthorisedOD,
                        baseRateCode: event.target.value
                    }
                }, () => this.setMyValue())
                break;
            case 'unauthorisedODSpread':
                this.setState({
                    unauthorisedOD: {
                        ...this.state.unauthorisedOD,
                        spread: event.target.value
                    }
                }, () => this.setMyValue())
                break;
            case 'unauthorisedODMinInterest':
                this.setState({
                    unauthorisedOD: {
                        ...this.state.unauthorisedOD,
                        minimumInterest: event.target.value
                    }
                }, () => this.setMyValue())
                break;
            case 'unauthorisedODMaxInterest':
                this.setState({
                    unauthorisedOD: {
                        ...this.state.unauthorisedOD,
                        maximumInterest: event.target.value
                    }
                }, () => this.setMyValue())
                break;
            default:
        }
    }

    setInputvalue = (name, value, event) => {
        // if (name === 'unauthorizedInterestTypeFloating') {
        //     this.setState({
        //         unauthorizedInterestTypeFloating: value,
        //         unauthorizedInterestTypeFixed: '',
        //     }, () => this.setMyValue())
        // } else if (name === 'unauthorizedInterestTypeFixed') {
        //     this.setState({
        //         unauthorizedInterestTypeFloating: '',
        //         unauthorizedInterestTypeFixed: value,
        //     }, () => this.setMyValue())
        // } 
        if (name === 'unauthorisedODFixedValue') {
            this.setState({
                unauthorisedOD: {
                    ...this.state.unauthorisedOD,
                    fixedValue: value,
                    marginBaseRate: ''
                }
            }, () => this.setMyValue())
        } else if (name === 'unauthorisedODMarginBaseRate') {
            this.setState({
                unauthorisedOD: {
                    ...this.state.unauthorisedOD,
                    marginBaseRate: value,
                    fixedValue: ''
                }
            }, () => this.setMyValue())
        }
    }

    getData = (data) => {
        this.payload.setPaylod(data);
        this.payloadOtherSetting.setPaylod(data);
    }

    setMyValue = () => {
        let localObj = {
            name: 'otherSettings',
            values: {
                frequencyInfo: this.state.frequencyInfo,
                baseCurrency: {
                    name: this.state.selectedBaseCurrency,
                    value: this.state.selectedBaseCurrency
                },
                odLimit: this.state.odLimit,
                unauthorisedOD: this.state.unauthorisedOD,
                // unauthorizedInterestTypeFloating: this.state.unauthorizedInterestTypeFloating,
                // unauthorizedInterestTypeFixed: this.state.unauthorizedInterestTypeFixed,
            }
        }
        this.getData(localObj);
    }

    setODLimit = (event) => {
        const updatedOtherSettings = {
            checkODLimit: event.target.checked,
            odLimit: event.target.checked ? 'N/A' : ''
        }
        if (event.target.checked) {
            updatedOtherSettings.unauthorisedOD = this.getInitialUnauthorisedODObject()
        }
        this.setState(updatedOtherSettings, () => this.setMyValue())
    }

    onFormSubmit = () => {
        const { productId } = this.props.match.params;
        const apiUrl = `/sows/${productId}/glses`;
        const { id, lid } = this.props.selectedSowProduct || {};

        const data = this.payload.getPayload()

        if (this.state.isIERequired !== undefined && data.notionalPooling) {
            data.notionalPooling.isIERequired = this.state.isIERequired
        }

        if (this.state.countryOfSow && this.state.countryOfSow.value !== data.notionalPooling.location.value && data.notionalPooling) {
            data.notionalPooling.location = this.state.countryOfSow
        }

        const payload = {
            id, lid, ...data
        }

        eapiClient(apiUrl, {
            method: "PUT",
            data: JSON.stringify(payload)
        }).then(({ data }) => {
            if (!isEmptyObject(data.responseData)) {
                this.props.setSowSelectedProduct(data.responseData)
                this.props.history.goBack()
            }
        })
    }

    handleDeleteStandAloneAccount = (e, id) => {
        const { productId } = this.props.match.params;
        const apiUrl = `/sows/${productId}/glses`;

        const payload = this.props.selectedSowProduct ? JSON.parse(JSON.stringify(this.props.selectedSowProduct)) : {}
        if (payload && payload.notionalPooling && payload.notionalPooling.poolingStructure && payload.notionalPooling.poolingStructure.standAloneAccount) {
            payload.notionalPooling.poolingStructure.standAloneAccount = payload.notionalPooling.poolingStructure.standAloneAccount.filter(acc => acc !== id)
        }

        eapiClient(apiUrl, {
            method: "PUT",
            data: JSON.stringify(payload)
        })
            .then(({ data }) => {
                if (!isEmptyObject(data.responseData)) {
                    this.props.setSowSelectedProduct(data.responseData)
                    this.loadTabStatus()
                    this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure)
                    this.onSowProductUpdate(data.responseData)
                }
            });
    }

    getGLSProductDetails = () => {
        const { productId } = this.props.match.params;
        const apiUrl = `/sows/${productId}/sowProductByGlsId`
        eapiClient(apiUrl).then(({ data }) => {
            if (data.responseData) {
                this.props.setSowSelectedProduct(data.responseData)
            }
        })
    }

    getCCrRateId = (name, fieldPrefix = '', isAggregate, parentFormName, formIndex) => {
        return isAggregate ? `${fieldPrefix}${name}${parentFormName}${formIndex}Field` : `${fieldPrefix || ""}${name}Field`
    }

    generateCCRRateBoxJsx = ({ name, boxLabel, subLabels, subNames, radioValues, isVisible, maxChars, isAggregate, parentFormName, formData, formIndex, defaultValue }, elementKey = 'ccrratebox-ie-odlimit') => {
        const visibilityCss = classNames("form-group row", {
            noDisplay: isVisible === 'false'
        });
        const disabled = this.props.customer.roleDetails.customer
        const boxLabelTranslated = this.translations(boxLabel);
        const currentWord = this.translations(subLabels)
        const convertedArray = (typeof currentWord === "string" && convertStringToArrayForOption(currentWord)) || [];

        const _jsx = (
            <div key={elementKey} className={visibilityCss} id={this.getCCrRateId(name, this.props.fieldPrefix, isAggregate, parentFormName, formIndex)}>
                <div className="col-lg-12 col-sm-12">
                    <CCRRateBox
                        name={isAggregate ? parentFormName + name + formIndex : name}
                        boxLabel={boxLabelTranslated}
                        disabled={disabled}
                        subLabels={convertedArray}
                        subNames={subNames}
                        radioValues={radioValues}
                        maxChars={maxChars}
                        defaultValue={defaultValue}
                        _value={formData}
                        setInputvalue={(values,) => {
                            this.setState({ unauthorisedOD: { ...this.state.unauthorisedOD, ...values } }, () => this.setMyValue())
                        }}
                        fieldPrefix={this.props.fieldPrefix} />
                </div>
            </div>
        );
        return _jsx;
    }

    getInitialUnauthorisedODObject = () => ({
        baseRate: "",
        baseRateCode: "",
        spread: "",
        fixedValue: false,
        marginBaseRate: "",
        minimumInterest: "",
        maximumInterest: "",
        interestRateType: "baseRate"
    })

    render() {
        if (this.props.pageJsonAccordian !== undefined && this.props.pageJson2 !== undefined && this.state.formJson !== undefined &&
            this.props.pageJson1 !== undefined && this.props.sowAgent !== undefined && this.props.pageJson2.defaultValue !== undefined) {
            // const { notionalPoolingTitle, glsAgent, refrenceId } = this.props.selectedSowProduct;
            const { notionalPoolingTitle, entityName, entityId } = this.props.sowAgent;
            const { accordion1, accordion2, accordion3 } = this.props.pageJsonAccordian;
            const subNames = ["Settlement date", "Settlement date"];
            const fieldPrefix = "text7";
            // const { unauthorizedInterestTypeFloating, unauthorizedInterestTypeFixed } = this.state
            let divJSX = ''
            if (this.state.formJson.par.staticText_InterestOptimisationrequired !== undefined) {
                divJSX = (
                    <div className="form-group row">
                        <label className="col-lg-4">
                            {this.translations(this.state.formJson.par.staticText_InterestOptimisationrequired.InterestOptimisationReq)}
                        </label>
                        <div className="col-lg-8 col-sm-12">
                            <div className="radiobtn">
                                <div className="Radiocontainer">
                                    <label className="radio-label">
                                        {this.translateWord(this.state.formJson.par.staticText_InterestOptimisationrequired.options)[0].split('=')[1]}
                                        <Radiobutton
                                            setInputvalue={this.handleSweepParticipantsRadioChange}
                                            name="isSweepOrderDefined"
                                            disabled={this.props.customer.roleDetails.customer}
                                            _value={this.state.isIERequired}
                                            value="true"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="radiobtn">
                                <div className="Radiocontainer">
                                    <label className="radio-label">
                                        {this.translateWord(this.state.formJson.par.staticText_InterestOptimisationrequired.options)[1].split('=')[1]}
                                        <Radiobutton
                                            setInputvalue={this.handleSweepParticipantsRadioChange}
                                            name="isSweepOrderDefined"
                                            disabled={this.props.customer.roleDetails.customer}
                                            _value={this.state.isIERequired}
                                            value="false"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            return (

                <div className="customer-details-container gdocs-notional-pooling-container">
                    {this.props.pageJson1 &&
                        <div className="pannel-heading-container">
                            <div>
                                <h2 className="pannel-heading">
                                    {this.translations(this.state.formJson.par.page_title_mainTitle.pageHeading)} <span>({entityId})</span>
                                </h2>
                            </div>
                            <p className="pannel-sub-heading">
                                {`${this.translations(this.props.pageJson1.agent)} : ${entityName}`} {notionalPoolingTitle !== undefined && notionalPoolingTitle !== '' ? `(${notionalPoolingTitle})` : ''}
                            </p>
                            <p className="optional-text">
                                <b>{this.translations(this.props.pageJson1.descriptionText)}</b>
                            </p>
                        </div>}
                    <div className="gdocs-clear-float"></div>
                    <NavListAccordionWrapper>
                        <NavListAccordion
                            lang={this.props.lang.currentLang.lang}
                            navAccHeading={`1. ${this.translations(accordion1)}`}
                            status={this.state.sowNotionalPoolStatus && this.state.sowNotionalPoolStatus.poolingStructure ? this.state.sowNotionalPoolStatus.poolingStructure.status : 'incomplete'}
                        >
                            <div className="addresses-section">
                                <div>
                                    <GlsNotionalPoolingStrucutre
                                        {...this.props}
                                        pageJson={this.props.pageJson1}
                                        deletePool={this.openDeletePool}
                                        deleteStandAloneAccount={this.handleDeleteStandAloneAccount}
                                        // getData={this.getData}
                                        lang={this.props.lang}
                                        history={this.props.history}
                                        isNavigate={this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate == true ? true : false}
                                        accounts={this.state.allAccounts}
                                        setSowSelectedProduct={this.props.setSowSelectedProduct}
                                        setCountryOfSow={(value = {}) => { this.setState({ countryOfSow: value }) }}
                                    />
                                </div>
                                <div className="gdocs-clear-float"></div>
                            </div>
                        </NavListAccordion>
                        <NavListAccordion
                            lang={this.props.lang.currentLang.lang}
                            navAccHeading={`2. ${this.translations(accordion2)}`}
                            status={this.state.sowNotionalPoolStatus && this.state.sowNotionalPoolStatus.otherSettings !== undefined ? this.state.sowNotionalPoolStatus.otherSettings.status : ''}
                        >
                            <div className="addresses-section">
                                <div className="other-setting-container">
                                    <div className="base-currency">
                                        <label>{this.translations(this.props.pageJson2.baseCurrency)}</label>
                                        <SimpleDropdown
                                            name="baseCurrency"
                                            defaultValue={this.translations(this.props.pageJson2.pleaseselect)}
                                            disabled={this.props.customer.roleDetails.customer}
                                            value={this.state.selectedBaseCurrency}
                                            options={this.state.baseCurrency}
                                            optionTextSelector="name"
                                            valueSelector="name"
                                            _onChange={this.onChangeBaseCurrency}
                                        />
                                        <div className="input-help-msg-section" style={{ width: '465px' }}>
                                            {this.translations(this.props.pageJson2.baseDescription)}</div>
                                    </div>
                                    <div className="gdocs-clear-float"></div>
                                    <div className="interest-period-wrapper">
                                        {
                                            <SweepFrequencyPicker
                                                name={this.translations(this.props.pageJson2.settlementDate)}
                                                boxLabel={this.translations(this.props.pageJson2.interestPeriod)}
                                                mandatoryMessage={this.translations(this.props.pageJson2.validtimeentrymanmsg)}
                                                subLabels={[this.translations(this.props.pageJson2.settlementDate), this.translations(this.props.pageJson2.settlementDate)]}
                                                subNames={subNames}
                                                dataDictionaryURI={this.dataDictionaryURI}
                                                disabled={this.props.customer.roleDetails.customer}
                                                setInputvalue={this.setFormElementData}
                                                fieldPrefix={fieldPrefix}
                                                _value={this.state.frequencyInfo}
                                                lang={this.props.lang}
                                                isCheckShow={false}
                                            />
                                        }
                                    </div>
                                    <div className="gdocs-clear-float"></div>
                                    <div className="other-setting">
                                        <div className="detail-setting--body-section-row">
                                            <div className="od-limit-container">
                                                <label>{this.translations(this.props.pageJson2.grpLimit)}</label>
                                                <input
                                                    className="od-row-input"
                                                    type="text"
                                                    onChange={(event) => this._getData(event)}
                                                    name="odLimit"
                                                    disabled={this.state.checkODLimit || this.props.customer.roleDetails.customer}
                                                    maxlength="10"
                                                    value={this.state.odLimit} />

                                                <div className="gdocs-display-table gdocs-mleft-30">
                                                    <Checkbox
                                                        name={`set_ODLimit`}
                                                        disabled={this.props.customer.roleDetails.customer}
                                                        checked={this.state.checkODLimit}
                                                        onChange={(event) => this.setODLimit(event)}
                                                        controlled
                                                    />
                                                </div>
                                                <span className="input-suffix-sign">{this.translations(this.props.pageJson2.na)}</span>
                                            </div>
                                        </div>
                                        <div className="detail-setting--body-section-row">
                                            {/* {!this.state.checkODLimit &&
                                                <div className="">
                                                    <label>{this.translations(this.props.pageJson2.interestType)}</label>
                                                    <span className="gdocs-mleft-30">
                                                        <label className="radio-group gdocs-mright-30">
                                                            <Radiobutton
                                                                setInputvalue={this.setInputvalue.bind(this, 'unauthorizedInterestTypeFloating')}
                                                                name={`interestType`}
                                                                disabled={this.props.customer.roleDetails.customer}
                                                                value='true'
                                                                _value={unauthorizedInterestTypeFloating}
                                                            />
                                                            {this.translations(this.props.pageJson2.floating)}
                                                        </label>
                                                        <label className="radio-group">
                                                            <Radiobutton
                                                                setInputvalue={this.setInputvalue.bind(this, 'unauthorizedInterestTypeFixed')}
                                                                name={`interestType`}
                                                                disabled={this.props.customer.roleDetails.customer}
                                                                value='false'
                                                                _value={unauthorizedInterestTypeFixed}
                                                            />
                                                            {this.translations(this.props.pageJson2.fixed)}
                                                        </label>
                                                    </span>
                                                </div>
                                            } */}
                                        </div>
                                        {(this.state.checkODLimit === false || this.state.odLimit !== "N/A") && this.props.pageJson2 && this.props.pageJson2.guideccrrateUnauthorizedOD ?
                                            <Fragment>
                                                <h4>{this.translations(this.props.pageJson2.unauthorisedOd)}</h4>
                                                {this.generateCCRRateBoxJsx({ ...this.props.pageJson2.guideccrrateUnauthorizedOD, formData: this.state.unauthorisedOD }, "ccrratebox-ie-odlimit")}
                                            </Fragment>
                                            : null
                                        }
                                        {/* {!this.state.checkODLimit &&
                                            <div className="detail-setting--body-section-row">
                                                <div className="row-field">
                                                    <label>{this.translations(this.props.pageJson2.baserateCredit)}</label>
                                                    <input
                                                        type="text"
                                                        onChange={(event) => this._getData(event)}
                                                        name="unauthorisedODbaseRate"
                                                        disabled={this.props.customer.roleDetails.customer}
                                                        maxlength="50"
                                                        value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.baseRate : ''}
                                                    />
                                                </div>
                                                {!this.props.customer.roleDetails.customer
                                                    ? <div className="row-field">
                                                        <label>{this.translations(this.props.pageJson2.code)}</label>
                                                        <input
                                                            type="text"
                                                            onChange={(event) => this._getData(event)}
                                                            name="unauthorisedODCode"
                                                            maxlength="5"
                                                            placeholder={this.props.pageJson2.defaultValue && this.props.pageJson2.defaultValue[1]}
                                                            value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.baseRateCode : ''}
                                                        />
                                                    </div>
                                                    : ''}

                                                <div className="row-field">
                                                    <label>{this.translations(this.props.pageJson2.spreadCredit)}</label>
                                                    <input
                                                        type="text"
                                                        onChange={(event) => this._getData(event)}
                                                        name="unauthorisedODSpread"
                                                        disabled={this.props.customer.roleDetails.customer}
                                                        maxlength="7"
                                                        value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.spread : ''}
                                                    />
                                                </div>
                                                <div className="row-field select-radio">
                                                    <label className="radio-group gdocs-mright-30">
                                                        <Radiobutton
                                                            name={`unauthorisedOD`}
                                                            disabled={this.props.customer.roleDetails.customer}
                                                            value='true'
                                                            _value={this.state.unauthorisedOD !== undefined ? this.state.unauthorisedOD.marginBaseRate : ''}
                                                            setInputvalue={this.setInputvalue.bind(this, 'unauthorisedODMarginBaseRate')}
                                                        />
                                                        {this.translations(this.props.pageJson2.margin)}
                                                    </label>
                                                    <label className="radio-group">
                                                        <Radiobutton
                                                            name={`unauthorisedOD`}
                                                            disabled={this.props.customer.roleDetails.customer}
                                                            value='false'
                                                            _value={this.state.unauthorisedOD !== undefined ? this.state.unauthorisedOD.fixedValue : ''}
                                                            setInputvalue={this.setInputvalue.bind(this, 'unauthorisedODFixedValue')}
                                                        />
                                                        {this.translations(this.props.pageJson2.fixedValue)}
                                                    </label>
                                                </div>
                                            </div>
                                        } */}
                                        {/* {!this.state.checkODLimit &&
                                            <div className="detail-setting--body-section-row">
                                                <div className="row-field">
                                                    <label>{this.translations(this.props.pageJson2.minInterest)}</label>
                                                    <input
                                                        placeholder={this.props.pageJson2.defaultValue[5]}
                                                        type="text"
                                                        onChange={(event) => this._getData(event)}
                                                        name="unauthorisedODMinInterest"
                                                        disabled={this.props.customer.roleDetails.customer}
                                                        maxlength="10"
                                                        value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.minimumInterest : ''}
                                                    />
                                                </div>
                                                <div className="row-field">
                                                    <label>{this.translations(this.props.pageJson2.maxInterest)}</label>
                                                    <input
                                                        placeholder={this.props.pageJson2.defaultValue[6]}
                                                        type="text"
                                                        onChange={(event) => this._getData(event)}
                                                        name="unauthorisedODMaxInterest"
                                                        disabled={this.props.customer.roleDetails.customer}
                                                        maxlength="10"
                                                        value={typeof this.state.unauthorisedOD !== 'undefined' ? this.state.unauthorisedOD.maximumInterest : ''}
                                                    />
                                                </div>
                                            </div>
                                        } */}
                                    </div>
                                    <div className="gdocs-clear-float"></div>
                                    <div key="buttons-wrapper" className="form-buttons-save-section">
                                        <div className="form-buttons-wrapper">
                                            <button
                                                className="gdocs-btn-submit"
                                                onClick={this.onOtherSettingTabDataSubmit}
                                            >Refresh</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </NavListAccordion>
                        {this.props.selectedSowProduct.notionalPooling.poolingStructure.pools.length > 0 || this.props.selectedSowProduct.notionalPooling.poolingStructure.standAloneAccount.length > 0 ?
                            <NavListAccordion
                                lang={this.props.lang.currentLang.lang}
                                navAccHeading={`3. ${this.translations(accordion3)}`}
                                status={this.state.sowNotionalPoolStatus && this.state.sowNotionalPoolStatus.interestOptimisation !== undefined ? this.state.sowNotionalPoolStatus.interestOptimisation.status : ''}
                            >
                                <div className="addresses-section">
                                    {divJSX}
                                    {

                                        this.state.isIERequired !== undefined && this.state.isIERequired && this.state.standID && this.state.standID.length > 0
                                            ? this.renderStandAlonForm(this.state.standID)
                                            : ((this.state.isIERequired !== undefined && !this.state.isIERequired)
                                                || (this.props.selectedSowProduct.notionalPooling.interestOptimisations && this.props.selectedSowProduct.notionalPooling.interestOptimisations.length) > 0
                                                ? this.getInterestOptimizationDataOnNoSelection() : '')
                                    }
                                    {
                                        this.state.isIERequired !== undefined && this.state.isIERequired && this.state.poolID && this.state.poolID.length > 0
                                            ? this.renderPoolForm(this.state.poolID)
                                            : ((this.state.isIERequired !== undefined && !this.state.isIERequired)
                                                || (this.props.selectedSowProduct.notionalPooling.interestOptimisations && this.props.selectedSowProduct.notionalPooling.interestOptimisations.length) > 0
                                                ? this.getInterestOptimizationDataOnNoSelection() : '')
                                    }
                                    <div className="gdocs-clear-float"></div>
                                    <div key="buttons-wrapper" className="form-buttons-save-section">
                                        <div className="form-buttons-wrapper">
                                            <button
                                                className="gdocs-btn-submit"
                                                onClick={this.onInterestOptimizationTabDataSubmit}
                                            >Refresh</button>
                                        </div>
                                    </div>
                                </div>
                            </NavListAccordion> : ''}
                    </NavListAccordionWrapper>
                    <div class="save-btn-right"><button onClick={this.onFormSubmit} class="btn save-btn">Save and return</button></div>
                </div>
            )
        }
        else {
            return (<div>Loading...</div>);
        }
    }

}

// Other setting payload
class otherSettingPayload {
    constructor() {
        this.data = {}
        this.data.notionalPooling = {
            poolingStructure: null,
            interestOptimisations: null,
            otherSettings: null
        }
    }

    setPaylod(data) {
        switch (data.name) {
            case 'otherSettings': {
                this.data.notionalPooling.otherSettings = data.values;
            }
                break;
            default:
                return this.data.notionalPooling.otherSettings = {
                    unauthorizedInterestTypeFloating: true,
                    frequencyInfo: {
                        timeZone: null,
                        frequencyType: {
                            name: "Monthly",
                            value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
                        },
                        frequencyDetails: {
                            name: null,
                            value: null
                        },
                        frequencyDetailValue: {
                            name: null,
                            value: null
                        },
                        annualDate: null,
                        dates: []
                    }
                }
        }
    }
    getPayload() {
        return this.data;
    }
}

// Main payload
class NotionalPoolingPayload {
    constructor() {
        this.data = {}
        this.data.notionalPooling = {
            poolingStructure: null,
            interestOptimisations: null,
            otherSettings: null
        }

    }
    setPrePopulateData(poolingStructure) {
        this.data.notionalPooling.poolingStructure = poolingStructure;
        // this.data.notionalPooling.otherSettings = {
        //   unauthorizedInterestTypeFloating: true,
        //   frequencyInfo: {
        //     timeZone: null,
        //     frequencyType: {
        //       name: "Monthly",
        //       value: "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly"
        //     },
        //     frequencyDetails: {
        //       name: null,
        //       value: null
        //     },
        //     frequencyDetailValue: {
        //       name: null,
        //       value: null
        //     },
        //     annualDate: null,
        //     dates: []
        //   }
        // }
    }
    setPaylod(data) {
        switch (data.name) {
            case 'interestOptimisations':
                this.data.notionalPooling.interestOptimisations = data.values || null;
                break;
            case 'otherSettings':
                this.data.notionalPooling.otherSettings = data.values;
                break;
            default:
        }
    }
    getPayload() {
        return this.data;
    }
}

class interestOptimizationPayload {
    constructor() {
        this.data = {}
        this.data.notionalPooling = {
            poolingStructure: null,
            interestOptimisations: null,
            otherSettings: null
        }
    }
    setPaylod(data) {
        switch (data.name) {
            case 'interestOptimisations':
                this.data.notionalPooling.interestOptimisations = data.values || null;
                break;
            default:
        }
    }
    getPayload() {
        return this.data;
    }
}

const mapStateToProps = state => {
    let poolAccounts = []
    const { location = {}, notionalPooling = {} } = (state.sowEntities && state.sowEntities.selectedSowProduct) || {}
    if (state.sowEntities.allAccounts) {
        poolAccounts = state.sowEntities.allAccounts.filter(acc => (notionalPooling.poolingStructure && notionalPooling.poolingStructure.pools
            && !notionalPooling.poolingStructure.pools.find(sel => sel === acc.id)) && location.value === acc.location.value)
    }
    return {
        lang: state.lang,
        statuses: state.currentProductNotionalPooling.statuses,
        pageJson: state.currentProductNotionalPooling.pageJson,
        pageJson1: state.currentProductNotionalPooling.pageJson1,
        pageJson2: state.currentProductNotionalPooling.pageJson2,
        pageJsonAccordian: state.currentProductNotionalPooling.pageJsonAccordian,
        sowAgent: state.sowEntities.sowAgent || {},
        customer: state.auth.userDetails,
        basicDetailsAccounts: poolAccounts,
        accounts: poolAccounts,
        selectedSowProduct: (state.sowEntities && state.sowEntities.selectedSowProduct) || {},
        currency: state.currentProductNotionalPooling.currency,
        cases: state.cases,
        dataIOFormJson: state.currentProductNotionalPooling.dataIOFormJson,
        interestPeriodSettlementDate: state.currentProductNotionalPooling.interestPeriodSettlementDate,
        poolIdAfterSaveRefresh: state.currentProductNotionalPooling.poolIdAfterSaveRefresh,
        savedSow: (state.sowEntities && state.sowEntities.savedSow) || {}
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setProductNotionalPooling: data => {
            dispatch(setProductNotionalPooling(data))
        },
        setStatus: statuses => {
            dispatch(setStatus(statuses))
        },
        setPageJson: par => {
            dispatch(setPageJson(par))
        },
        setPageJson1: par => {
            dispatch(setPageJson1(par))
        },
        setPageJson2: par => {
            dispatch(setPageJson2(par))
        },
        setPageJsonAccordian: par => {
            dispatch(setPageJsonAccordian(par))
        },
        setPartyCurrency: currency => {
            dispatch(setPartyCurrency(currency))
        },
        setSowProductAllAccounts: accounts => {
            dispatch(setSowProductAllAccounts(accounts))
        },
        setSowSelectedProduct: data => {
            dispatch(setSowSelectedProduct(data));
        },
    }
}





export default connect(mapStateToProps, mapDispatchToProps)(NotionalPoolSummary)


// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/index.js